export enum RoleType {
    USER = 'USER',
    HOST = 'HOST',
    ADMIN = 'ADMIN'
}

export enum CampaignStatus {
    DRAFT = 'DRAFT',
    SENT = 'SENT',
    FAILED = 'FAILED',
    SENT_PARTIALLY = 'SENT_PARTIALLY'
}

export enum CampaignChannel {
    SMS = 'SMS',
    MOBILE_PUSH = 'MOBILE_PUSH'
}

export interface CampaignUser {
    id: string;
    name: string;
    phoneNumber: string;
    countryCode: string;
    role: RoleType;
    mobileAppInstalled: boolean;
}

export interface Campaign {
    id: string;
    name: string;
    text: string;
    channel?: CampaignChannel;
    countryCode: string;
    roles: RoleType[];
    includedUserIds: string[];
    status: CampaignStatus;
    failedPhoneNumbers: string[];
    createdAt: string;
}

export interface CreateCampaignRequest {
    name: string;
    text: string;
    channel: CampaignChannel;
    countryCode: string;
    roles: RoleType[];
    includedUserIds: string[];
}
